import { render, staticRenderFns } from "./OrgBasicInfoSet.vue?vue&type=template&id=15ae2f34&scoped=true"
import script from "./OrgBasicInfoSet.vue?vue&type=script&lang=js"
export * from "./OrgBasicInfoSet.vue?vue&type=script&lang=js"
import style0 from "./OrgBasicInfoSet.vue?vue&type=style&index=0&id=15ae2f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae2f34",
  null
  
)

export default component.exports